import { api } from "@lib/orpc-client";
import useSWR from "swr";

const useSupportedVirtualAccountInstructions = () => {
    const { data, isLoading, error } = useSWR(
        'walletV2.virtualAccount.topUpInstruction',
        () => api.walletV2.virtualAccount.topUpInstruction({})
    )
    return {
        data,
        isLoading,
        error
    }
}

export default useSupportedVirtualAccountInstructions
